/* ============================================================
   LBL CORE — shared data, state, builder logic & demo cart for
   all Little Big Love sections. Exposed as window.LBL.
   Every DOM lookup is null-guarded, so any section can be added,
   removed or reordered independently. State lives here and is
   shared across all sections (connected experience).
   Re-initialises on DOMContentLoaded and shopify:section:load.
   ============================================================ */
(function(){
  if(window.LBL) return; // singleton

  var DOMAIN='https://disignletters.com';
  var CDN='https://cdn.shopify.com/s/files/1/0603/9804/3300/';
  var CFG=window.LBL_CONFIG||{};
  var SHIP={threshold:(CFG.shipThreshold||55)};

  var pdp=function(h){return DOMAIN+'/products/'+h;};

  /* ---- SKU registry (price + image + product handle) ---- */
  var SKU={
    '90501007CORAL':{p:85,img:'files/90501007CORAL_2fa004a4-274f-4b31-9a93-c78adae53351.jpg',h:'little-big-love-bracelet-goldplated'},
    '90501007BURGUNDY':{p:85,img:'files/90501007BURGUNDY.jpg',h:'little-big-love-bracelet-burgundy-goldplated'},
    '90501022PEARL':{p:110,img:'files/90501022PEARL.jpg',h:'pearl-little-big-love-bracelet-gold-plated'},
    '90501012CORAL':{p:85,img:'files/90501012CORAL.jpg',h:'little-big-love-bracelet-silver'},
    '90501012BURGUNDY':{p:85,img:'files/90501012BURGUNDY.jpg',h:'little-big-love-bracelet-burgundy-silver'},
    '90304015CORAL':{p:115,img:'products/90304015CORAL.jpg',h:'little-big-love-necklace-goldplated'},
    '90304015BURGUNDY':{p:115,img:'files/90304015BURGUNDY.jpg',h:'little-big-love-necklace-burgundy-goldplated'},
    '90304018PEARL':{p:159,img:'files/90304018PEARL.jpg',h:'pearl-little-big-love-necklace-gold-plated'},
    '90101017CORAL':{p:110,img:'files/90101017CORAL_1_555d7169-8812-4d11-ad0b-01f168116bdd.jpg',h:'little-big-love-necklace-silver'},
    '90101017BURGUNDY':{p:110,img:'files/90101017BURGUNDY.jpg',h:'little-big-love-necklace-burgundy-silver'},
    '90401010CORAL':{p:59,img:'products/90401010CORAL.jpg',h:'little-big-love-earstuds-set-of-2-pcs-goldplated'},
    '90401017PEARL':{p:95,img:'files/90401017PEARL.jpg',h:'pearl-little-big-love-earstuds-gold-plated-set-of-2-pcs'},
    '90402007CORAL':{p:79,img:'products/90402007CORAL.jpg',h:'little-big-love-earchain-set-of-2-pcs-goldplated'},
    '90405006PEARL':{p:110,img:'files/90405006PEARL.jpg',h:'pearl-little-big-love-ear-hanger-gold-plated-set-of-2-pcs'},
    '90403031CORAL':{p:120,img:'files/90403031CORAL.jpg',h:'little-big-love-hoops-set-of-2-pcs-goldplated'},
    '90403035CORAL':{p:120,img:'files/90403035CORAL_9cf7ea0a-445c-4249-8c3d-92779a9a32fb.jpg',h:'little-big-love-hoops-set-of-2-pcs-silverplated'},
    '90602010CORAL':{p:69,img:'products/90602010CORAL.jpg',h:'little-big-love-ring-goldplated'},
    '90606003PEARL':{p:95,img:'files/90606003PEARL.jpg',h:'pearl-little-big-love-ring-gold-plated'},
    '90602015CORAL':{p:69,img:'files/90602015CORAL.jpg',h:'little-big-love-ring-silver'}
  };
  var CATALOG={
    gold:{
      coral:{bracelet:'90501007CORAL',necklace:'90304015CORAL',earstuds:'90401010CORAL',earhanger:'90402007CORAL',hoops:'90403031CORAL',ring:'90602010CORAL'},
      burgundy:{bracelet:'90501007BURGUNDY',necklace:'90304015BURGUNDY'},
      pearl:{bracelet:'90501022PEARL',necklace:'90304018PEARL',earstuds:'90401017PEARL',earhanger:'90405006PEARL',ring:'90606003PEARL'}
    },
    silver:{
      coral:{bracelet:'90501012CORAL',necklace:'90101017CORAL',ring:'90602015CORAL',hoops:'90403035CORAL'},
      burgundy:{bracelet:'90501012BURGUNDY',necklace:'90101017BURGUNDY'}
    }
  };
  var TYPE_ORDER=['bracelet','necklace','earstuds','earhanger','hoops','ring'];
  var TYPE_NAME={bracelet:'Armband',necklace:'Halskette',earstuds:'Ohrstecker',earhanger:'Ohrhänger',hoops:'Creolen',ring:'Ring'};
  var colorNames={coral:'Coral',burgundy:'Burgundy',pearl:'Pearl'};
  var metalNames={gold:'Gold',silver:'Silber'};

  var INITIAL={
    letterImg:function(L){return CDN+'files/letter_charm_'+L+'.jpg';},
    sizes:{
      '10mm':{gold:{sku:'90201547',p:45,h:'archetyp-anhanger-10mm-a-z-18k-vergoldet'}, silver:{sku:'90201548',p:40,h:'archetyp-anhanger-10mm-a-z-silber'}},
      '16mm':{gold:{sku:'90201544',p:59,h:'archetyp-anhanger-16mm-a-z-18k-vergoldet'}},
      '30mm':{gold:{sku:'90201001',p:100,h:'archetyp-anhanger-a-z-30-mm-18k-vergoldet'}}
    }
  };
  var MEGA={p:47,h:'big-love-charm-18k-gold-plated'};

  var STACK={
    bracelet:{ handle:'bracelet-stack-gold', title:'Bracelet stack gold', products:[
      {sku:'90501007CORAL',name:'Little Big Love · Coral',p:85,img:'files/90501007CORAL_2fa004a4-274f-4b31-9a93-c78adae53351.jpg'},
      {sku:'90501007BURGUNDY',name:'Little Big Love · Burgundy',p:85,img:'files/90501007BURGUNDY.jpg'},
      {sku:'90501010A',name:'Archetype Buchstabe A–Z',p:85,img:'files/90501010A.jpg'},
      {sku:'90501022PEARL',name:'Pearl Little Big Love',p:110,img:'files/90501022PEARL.jpg'},
      {sku:'90501023HAPPY',name:'Vocabulary · Happy',p:110,img:'files/90501023HAPPY.jpg'},
      {sku:'90501020YELLOW',name:'When life gives you lemons',p:95,img:'files/90501020YELLOW.jpg'},
      {sku:'90506001PEARL',name:'Pearl Charm Lock Chain 5 mm',p:175,img:'files/90506001PEARL.jpg'},
      {sku:'90501018CORALLOVE',name:'Keywords Chain · Coral Love',p:110,img:'files/90501018CORALLOVE.jpg'},
      {sku:'90506002GOLD',name:'Ruth Anchor Charm Lock',p:120,img:'files/90506002GOLD.jpg'},
      {sku:'90501016GOLD',name:'Chunky Square Link · Large',p:135,img:'files/90501016GOLD.jpg'},
      {sku:'90501015GOLD',name:'Chunky Square Link · Small',p:110,img:'files/90501015GOLD.jpg'},
      {sku:'90501023CARPEDIEM',name:'Vocabulary · Carpe Diem',p:110,img:'files/90501023CARPEDIEM.jpg'}
    ]}
  };

  /* ---- shared state (persists across re-init) ---- */
  var state={metal:'gold',color:'coral',type:'bracelet',initialOn:false,iLetter:'A',iSize:'10mm',iMetal:'gold',megaOn:false};
  var setSelection={bracelet:true};
  var stackType='bracelet';
  var stackItems=[];
  var stackPick=0;
  var cart=[];
  var CHARM_TYPES=['bracelet','necklace'];
  var ALPHABET='ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var ddBound=false;

  /* ---- helpers ---- */
  function $(id){return document.getElementById(id);}
  function eur(n){return n+' €';}
  function skuOf(m,t,c){var x=CATALOG[m];return x&&x[c]?x[c][t]:undefined;}
  function priceFor(m,t,c){var s=skuOf(m,t,c);return s?SKU[s].p:undefined;}
  function imgOf(s){return s&&SKU[s]?CDN+SKU[s].img:CDN+'files/90501007CORAL_2fa004a4-274f-4b31-9a93-c78adae53351.jpg';}
  function imgFor(m,t,c){return imgOf(skuOf(m,t,c));}
  function handleFor(m,t,c){var s=skuOf(m,t,c);return s&&SKU[s].h?SKU[s].h:'little-big-love-bracelet-goldplated';}
  function colorAvailable(m,c){return !!(CATALOG[m]&&CATALOG[m][c]);}
  function availTypes(m,c){var x=CATALOG[m]&&CATALOG[m][c];return x?TYPE_ORDER.filter(function(t){return x[t]!==undefined;}):[];}
  function canCharm(){return CHARM_TYPES.indexOf(state.type)>-1;}
  function charmCfg(){var sz=INITIAL.sizes[state.iSize];var m=sz[state.iMetal]?state.iMetal:'gold';return sz[m];}
  function charmPrice(){return charmCfg().p;}
  function stackDisc(n){return n>=5?0.20:n===4?0.18:n===3?0.15:n===2?0.10:0;}

  /* ---- builder: colours ---- */
  function renderColors(){
    var row=$('lbl-colorRow'); if(!row) return; row.innerHTML='';
    ['coral','burgundy','pearl'].forEach(function(c){
      var ok=colorAvailable(state.metal,c);
      var el=document.createElement('div');
      el.className='sw'+(state.color===c?' active':'')+(ok?'':' na');
      if(ok) el.onclick=function(){setColor(c);};
      el.innerHTML='<span class="chip col-'+c+'"></span><span class="lbl-t">'+colorNames[c]+'</span>';
      row.appendChild(el);
    });
    var mh= state.metal==='gold' ? {cls:'col-silverheart',lbl:'Silber'} : {cls:'col-goldheart',lbl:'Gold'};
    var el=document.createElement('div'); el.className='sw soon';
    el.innerHTML='<span class="chip '+mh.cls+'"></span><span class="lbl-t">'+mh.lbl+' Herz</span>';
    row.appendChild(el);
  }
  function renderTypes(){
    var g=$('lbl-typeRow'); if(!g) return; g.innerHTML='';
    var types=availTypes(state.metal,state.color);
    if(types.indexOf(state.type)<0) state.type=types[0];
    types.forEach(function(t){
      var el=document.createElement('div');
      el.className='hcard'+(state.type===t?' active':'');
      el.onclick=function(){setType(t);};
      el.innerHTML='<div class="ci" style="background-image:url(\''+imgFor(state.metal,t,state.color)+'\')"></div>'+
        '<div class="cn">'+TYPE_NAME[t]+'</div><div class="cp">'+eur(priceFor(state.metal,t,state.color))+'</div>';
      g.appendChild(el);
    });
  }

  /* ---- complete the set ---- */
  function renderSet(){
    var g=$('lbl-setRow'); if(!g) return; g.innerHTML='';
    var types=availTypes(state.metal,state.color);
    Object.keys(setSelection).forEach(function(k){ if(types.indexOf(k)<0) delete setSelection[k]; });
    if(Object.keys(setSelection).filter(function(k){return setSelection[k];}).length===0 && types[0]) setSelection[types[0]]=true;
    if($('lbl-setMetalName')) $('lbl-setMetalName').textContent=metalNames[state.metal];
    if($('lbl-setColorName')) $('lbl-setColorName').textContent=colorNames[state.color];
    types.forEach(function(t){
      var on=!!setSelection[t];
      var el=document.createElement('div');
      el.className='hcard'+(on?' on':'');
      el.onclick=function(){ setSelection[t]=!setSelection[t]; renderSet(); };
      el.innerHTML='<div class="tick">✓</div>'+
        '<div class="ci" style="background-image:url(\''+imgFor(state.metal,t,state.color)+'\')"></div>'+
        '<div class="cn">'+TYPE_NAME[t]+'</div><div class="cp">'+eur(priceFor(state.metal,t,state.color))+'</div>';
      g.appendChild(el);
    });
    updateSetSummary();
  }
  function setBundle(){
    var picked=availTypes(state.metal,state.color).filter(function(t){return setSelection[t];});
    var raw=picked.reduce(function(s,t){return s+priceFor(state.metal,t,state.color);},0);
    var disc=picked.length>=3?0.15:picked.length===2?0.10:0;
    return {count:picked.length,raw:raw,disc:disc,total:Math.round(raw*(1-disc)),picked:picked};
  }
  function updateSetSummary(){
    var b=setBundle();
    if($('lbl-setCount')) $('lbl-setCount').textContent=b.count;
    if($('lbl-setNew')) $('lbl-setNew').textContent=eur(b.total);
    var old=$('lbl-setOld'), pill=$('lbl-setSave');
    if(old&&pill){
      if(b.disc>0){ old.textContent=eur(b.raw); pill.textContent='−'+(b.disc*100)+'% · spare '+(b.raw-b.total)+' €'; }
      else { old.textContent=''; pill.textContent='wähle 2+'; }
    }
  }

  /* ---- stack ---- */
  function renderStackPicker(){
    if($('lbl-collName')) $('lbl-collName').textContent=STACK[stackType].title;
    var menu=$('lbl-ddMenu'); if(!menu) return; menu.innerHTML='';
    STACK[stackType].products.forEach(function(p,i){
      var o=document.createElement('div'); o.className='dd-opt'+(i===stackPick?' sel':'');
      o.onclick=function(){selectDD(i);};
      o.innerHTML='<span class="o-thumb" style="background-image:url(\''+CDN+p.img+'\')"></span><span class="o-name">'+p.name+'</span><span class="o-price">'+eur(p.p)+'</span>';
      menu.appendChild(o);
    });
    updateDDTrigger();
  }
  function updateDDTrigger(){
    var p=STACK[stackType].products[stackPick];
    if($('lbl-ddThumb')) $('lbl-ddThumb').style.backgroundImage='url(\''+CDN+p.img+'\')';
    if($('lbl-ddLabel')) $('lbl-ddLabel').textContent=p.name+' · '+eur(p.p);
  }
  function toggleDD(e){ if(e) e.stopPropagation(); var m=$('lbl-ddMenu'); if(m) m.classList.toggle('open'); }
  function selectDD(i){ stackPick=i; renderStackPicker(); var m=$('lbl-ddMenu'); if(m) m.classList.remove('open'); }
  function addStackFromSelect(){
    if(stackItems.length>=5){ toast('Maximal 5 Teile im Stack'); return; }
    stackItems.push(STACK[stackType].products[stackPick]); renderStackTray();
  }
  function removeStackItem(i){ stackItems.splice(i,1); renderStackTray(); }
  function renderStackTray(){
    var tray=$('lbl-stackTray'); if(!tray){ updateStackSummary(); return; } tray.innerHTML='';
    for(var i=0;i<5;i++){
      if(i<stackItems.length){
        var it=stackItems[i];
        var d=document.createElement('div'); d.className='tray-item'; d.style.backgroundImage='url(\''+CDN+it.img+'\')';
        d.innerHTML='<button class="rm" onclick="LBL.removeStackItem('+i+')">×</button>';
        tray.appendChild(d);
      } else if(i<2 || i<=stackItems.length){
        var s=document.createElement('div'); s.className='tray-slot'; s.textContent='+'; tray.appendChild(s);
      }
    }
    var hint=document.createElement('div'); hint.className='tray-hint';
    hint.textContent= stackItems.length<2?'Wähle 2–5 Stücke aus der Kollektion':(stackItems.length>=5?'Maximaler Stack erreicht':'Mehr Stücke = mehr Rabatt');
    tray.appendChild(hint);
    updateStackSummary();
  }
  function updateStackSummary(){
    var n=stackItems.length, raw=stackItems.reduce(function(s,i){return s+i.p;},0), d=stackDisc(n), total=Math.round(raw*(1-d));
    if($('lbl-stackCount')) $('lbl-stackCount').textContent=n;
    if($('lbl-stackNew')) $('lbl-stackNew').textContent=eur(total);
    var old=$('lbl-stackOld'), pill=$('lbl-stackSave');
    if(old&&pill){
      if(d>0){ old.textContent=eur(raw); pill.textContent='−'+(d*100)+'% · spare '+(raw-total)+' €'; }
      else { old.textContent=''; pill.textContent='wähle 2+'; }
    }
    var cta=$('lbl-stackCTA');
    if(cta){
      var skus=stackItems.map(function(i){return i.sku;}).join(',');
      cta.href=DOMAIN+'/collections/'+STACK[stackType].handle+(skus?('?preselect='+encodeURIComponent(skus)):'');
    }
  }
  function setStackType(t){ /* only bracelet collection live */ }
  function addStackToCart(){
    if(stackItems.length<2){toast('Wähle mindestens 2 Stücke');return;}
    var d=stackDisc(stackItems.length);
    stackItems.forEach(function(v){
      var unit=Math.round(v.p*(1-d));
      addToCart({name:v.name, meta:'Stack '+stackItems.length+'× −'+(d*100)+'%', price:unit, oldPrice:d>0?v.p:null, qty:1, img:CDN+v.img});
    });
    toast(stackItems.length+'er Stack hinzugefügt'); stackItems=[]; renderStackTray(); openCart();
  }

  /* ---- initial charm ---- */
  function renderInitialCard(){
    var sz=$('lbl-iniSizes');
    if(sz){ sz.innerHTML='';
      Object.keys(INITIAL.sizes).forEach(function(s){
        var el=document.createElement('div'); el.className='mini-pill'+(state.iSize===s?' active':'');
        el.textContent=s; el.onclick=function(){ state.iSize=s; if(!INITIAL.sizes[s][state.iMetal]) state.iMetal='gold'; renderInitialCard(); updateSticky(); };
        sz.appendChild(el);
      });
    }
    var mt=$('lbl-iniMetals');
    if(mt){ mt.innerHTML='';
      ['gold','silver'].forEach(function(m){
        var ok=!!INITIAL.sizes[state.iSize][m];
        var el=document.createElement('div'); el.className='mini-pill'+(state.iMetal===m?' active':'')+(ok?'':' na');
        el.textContent=metalNames[m]+(ok?'':' (nur 10 mm)'); if(ok) el.onclick=function(){ state.iMetal=m; renderInitialCard(); updateSticky(); };
        mt.appendChild(el);
      });
    }
    var g=$('lbl-iniGrid');
    if(g){ g.innerHTML='';
      ALPHABET.forEach(function(L){
        var el=document.createElement('div'); el.className='ini'+(state.iLetter===L?' active':''); el.textContent=L;
        el.onclick=function(){ state.iLetter=L; renderInitialCard(); updateSticky(); };
        g.appendChild(el);
      });
    }
    var usedMetal = INITIAL.sizes[state.iSize][state.iMetal] ? state.iMetal : 'gold';
    if($('lbl-iniThumb')) $('lbl-iniThumb').style.backgroundImage='url(\''+INITIAL.letterImg(state.iLetter)+'\')';
    if($('lbl-iniMeta')) $('lbl-iniMeta').textContent=state.iSize+' · '+metalNames[usedMetal]+' · „'+state.iLetter+'“';
    if($('lbl-iniPrice')) $('lbl-iniPrice').textContent='+ '+eur(charmPrice());
  }

  /* ---- selectors ---- */
  function setMetal(m){
    state.metal=m;
    var row=$('lbl-metalRow');
    if(row) row.querySelectorAll('.sw').forEach(function(s){ s.classList.toggle('active', s.getAttribute('data-metal')===m); });
    if(!colorAvailable(m,state.color)) state.color='coral';
    refresh();
  }
  function setColor(c){ state.color=c; refresh(); }
  function setType(t){ state.type=t; setSelection={}; setSelection[t]=true; refresh(); }
  function refresh(){ renderColors(); renderTypes(); renderSet(); updatePreview(); updateCharmAvailability(); updateSticky(); }

  /* ---- preview / sticky ---- */
  function currentItemPrice(){
    var p=priceFor(state.metal,state.type,state.color);
    if(canCharm()&&state.initialOn) p+=charmPrice();
    if(canCharm()&&state.megaOn) p+=MEGA.p;
    return p;
  }
  function updatePreview(){
    var img=imgFor(state.metal,state.type,state.color);
    if($('lbl-prevImg')) $('lbl-prevImg').style.backgroundImage='url(\''+img+'\')';
    if($('lbl-heroImg')) $('lbl-heroImg').src=img;
    if($('lbl-prevName')) $('lbl-prevName').textContent=TYPE_NAME[state.type];
    if($('lbl-prevMeta')) $('lbl-prevMeta').textContent=metalNames[state.metal]+' · '+colorNames[state.color]+' Herz';
    if($('lbl-prevPrice')) $('lbl-prevPrice').textContent=eur(currentItemPrice());
    if($('lbl-heroPrice')) $('lbl-heroPrice').textContent='ab '+eur(priceFor(state.metal,state.type,state.color));
    if($('lbl-prevPdp')) $('lbl-prevPdp').href=pdp(handleFor(state.metal,state.type,state.color));
    if($('lbl-heroPdp')) $('lbl-heroPdp').href=pdp(handleFor('gold','bracelet','coral'));
  }
  function updateSticky(){
    var nm=TYPE_NAME[state.type]+' · '+metalNames[state.metal]+' · '+colorNames[state.color];
    if(canCharm()&&state.initialOn) nm+=' · „'+state.iLetter+'“';
    if($('lbl-stickyName')) $('lbl-stickyName').textContent=nm;
    if($('lbl-stickyPrice')) $('lbl-stickyPrice').textContent=eur(currentItemPrice());
  }

  /* ---- charms availability ---- */
  function updateCharmAvailability(){
    var able=canCharm();
    var sec=$('lbl-charms'); if(sec) sec.style.display=able?'':'none';
    if(!able){
      state.initialOn=false; state.megaOn=false;
      setCtaState('lbl-tgInitial','lbl-tgInitialTxt',false);
      setCtaState('lbl-tgMega','lbl-tgMegaTxt',false);
    }
  }
  function setCtaState(btnId,txtId,on){
    var b=$(btnId); if(b) b.classList.toggle('on',on);
    var t=$(txtId); if(t) t.textContent=on?'Hinzugefügt ✓':'Hinzufügen';
  }
  function toggleInitial(){ if(!canCharm())return; state.initialOn=!state.initialOn; setCtaState('lbl-tgInitial','lbl-tgInitialTxt',state.initialOn); updateSticky(); }
  function toggleMega(){ if(!canCharm())return; state.megaOn=!state.megaOn; setCtaState('lbl-tgMega','lbl-tgMegaTxt',state.megaOn); updateSticky(); }

  /* ---- cart ---- */
  function addToCart(item){ cart.push(item); renderCart(); flashCart(); }
  function addCurrentToCart(){
    var price=priceFor(state.metal,state.type,state.color); var extras=[];
    if(canCharm()&&state.initialOn){price+=charmPrice();extras.push('Initial „'+state.iLetter+'“ '+state.iSize);}
    if(canCharm()&&state.megaOn){price+=MEGA.p;extras.push('Mega-Charm');}
    addToCart({name:TYPE_NAME[state.type]+' · '+metalNames[state.metal]+' · '+colorNames[state.color],
      meta:extras.join(' · ')||(metalNames[state.metal]+' · '+colorNames[state.color]+' Herz'),
      price:price,qty:1,img:imgFor(state.metal,state.type,state.color)});
    toast('In den Warenkorb gelegt');
  }
  function addSetToCart(){
    var b=setBundle();
    if(b.count<1){toast('Wähle mindestens 1 Teil');return;}
    b.picked.forEach(function(t){
      var unit=priceFor(state.metal,t,state.color), ud=Math.round(unit*(1-b.disc));
      addToCart({name:TYPE_NAME[t]+' · '+metalNames[state.metal]+' · '+colorNames[state.color],
        meta:b.disc>0?('Set −'+(b.disc*100)+'%'):metalNames[state.metal], price:ud,
        oldPrice:b.disc>0?unit:null, qty:1, img:imgFor(state.metal,t,state.color)});
    });
    toast(b.count+'-teiliges Set hinzugefügt'); openCart();
  }
  function changeQty(i,d){ cart[i].qty+=d; if(cart[i].qty<=0) cart.splice(i,1); renderCart(); }
  function renderCart(){
    if($('lbl-cartCount')) $('lbl-cartCount').textContent=cart.reduce(function(s,i){return s+i.qty;},0);
    var wrap=$('lbl-ditems');
    if(wrap){
      if(cart.length===0) wrap.innerHTML='<div class="dempty">Dein Warenkorb ist noch leer.</div>';
      else wrap.innerHTML=cart.map(function(it,i){return '<div class="di"><div class="dimg" style="background-image:url(\''+it.img+'\')"></div>'+
        '<div style="flex:1;min-width:0"><div class="dn">'+it.name+'</div><div class="dm">'+(it.meta||'')+'</div>'+
        (it.oldPrice?'<div class="save-tag">statt '+it.oldPrice+' €</div>':'')+
        '<div class="dctrl"><button class="qbtn" onclick="LBL.changeQty('+i+',-1)">−</button>'+
        '<span style="font-size:13.5px">'+it.qty+'</span>'+
        '<button class="qbtn" onclick="LBL.changeQty('+i+',1)">+</button>'+
        '<span class="dp">'+(it.price*it.qty)+' €</span></div></div></div>';}).join('');
    }
    var sub=cart.reduce(function(s,i){return s+i.price*i.qty;},0);
    var sav=cart.reduce(function(s,i){return s+(i.oldPrice?(i.oldPrice-i.price)*i.qty:0);},0);
    if($('lbl-subTotal')) $('lbl-subTotal').textContent=eur(sub);
    if($('lbl-grandTotal')) $('lbl-grandTotal').textContent=eur(sub);
    var sl=$('lbl-savingsLine');
    if(sl){ if(sav>0){sl.style.display='flex'; if($('lbl-savingsAmt')) $('lbl-savingsAmt').textContent='−'+sav+' €';} else sl.style.display='none'; }
    var remain=Math.max(0,SHIP.threshold-sub), fill=Math.min(100,(sub/SHIP.threshold)*100);
    if($('lbl-shipFill')) $('lbl-shipFill').style.width=fill+'%';
    if($('lbl-shipMsg')) $('lbl-shipMsg').innerHTML= remain>0?('Noch <b>'+remain+' €</b> bis zum kostenlosen Versand'):'🎉 Du hast <b>kostenlosen Versand</b>!';
  }
  function openCart(){ if($('lbl-overlay'))$('lbl-overlay').classList.add('open'); if($('lbl-drawer'))$('lbl-drawer').classList.add('open'); }
  function closeCart(){ if($('lbl-overlay'))$('lbl-overlay').classList.remove('open'); if($('lbl-drawer'))$('lbl-drawer').classList.remove('open'); }
  function flashCart(){var c=$('lbl-cartCount'); if(!c)return; c.style.transform='scale(1.4)';setTimeout(function(){c.style.transform='scale(1)';},200);}
  var toastT; function toast(m){var t=$('lbl-toast'); if(!t){ t=document.createElement('div'); t.id='lbl-toast'; t.className='lbl-toast'; document.body.appendChild(t);} t.textContent=m;t.classList.add('show');clearTimeout(toastT);toastT=setTimeout(function(){t.classList.remove('show');},1900);}

  function setShip(n){ SHIP.threshold=n; if($('lbl-annShip')) $('lbl-annShip').textContent=eur(n); if($('lbl-valShip')) $('lbl-valShip').textContent=eur(n); renderCart(); }

  /* ---- init / re-init ---- */
  function init(){
    if($('lbl-annShip')) $('lbl-annShip').textContent=eur(SHIP.threshold);
    if($('lbl-valShip')) $('lbl-valShip').textContent=eur(SHIP.threshold);
    renderColors(); renderTypes(); renderSet(); renderStackPicker(); renderStackTray(); renderInitialCard();
    updatePreview(); updateCharmAvailability(); updateSticky(); renderCart();
    if(!ddBound){
      ddBound=true;
      document.addEventListener('click',function(e){ var dd=$('lbl-stackDD'); if(dd&&!dd.contains(e.target)){ var m=$('lbl-ddMenu'); if(m) m.classList.remove('open'); } });
    }
  }

  window.LBL={
    init:init, setMetal:setMetal, setColor:setColor, setType:setType,
    toggleInitial:toggleInitial, toggleMega:toggleMega,
    addCurrentToCart:addCurrentToCart, addSetToCart:addSetToCart,
    toggleDD:toggleDD, selectDD:selectDD, addStackFromSelect:addStackFromSelect,
    removeStackItem:removeStackItem, addStackToCart:addStackToCart, setStackType:setStackType,
    openCart:openCart, closeCart:closeCart, changeQty:changeQty, setShip:setShip
  };

  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
